export default __webpack_public_path__ + "static/media/10.0388c609.png";